import { TPostClipLogo, TPostClipPeople } from '@/features/clips/types';
import {
  TClipPresence,
  TPostSegmentLogo,
  TPostSegmentPeople,
  TSegmentPresence,
} from '@/features/segments/types';

/**
 * Discriminates the type of presence view/group used across the UI
 * (table columns, group options, etc.).
 *
 * Note: this is distinct from the `kind` field on data types (`TSegmentLogo`,
 * `TClipLogo`, etc.) which uses the singular forms `'logo'` / `'people'` as
 * API contracts and should not be changed.
 */
export enum PresenceTypeEnum {
  LOGOS = 'logos',
  PEOPLE = 'people',
}

export type TPresenceItem = TSegmentPresence | TClipPresence;
export type TPostPresenceItem =
  | TPostSegmentLogo
  | TPostClipLogo
  | TPostSegmentPeople
  | TPostClipPeople;
